import './logo.scss';
import React from 'react';
import { useState, useEffect, useContext, useCallback } from 'react';
import { AppContext } from '../../context/appContext';
import If from '../../common/components/if';
import { toHome } from '../../services/authorizationService';
import ImageUtil from '../../common/utils/imageUtil';
export interface IProps {
    trackEvent: string;
    hideDefaultLogo: boolean;
    entry?: VoidFunction;
    onLogoLoaded: VoidFunction
}

export function Logo(props: IProps) {
    const appContext = useContext(AppContext);
    const [src, setSrc] = useState('');
    const { entry, trackEvent, hideDefaultLogo, onLogoLoaded } = props;

    const handleLogoLoaded = useCallback(() => {
        if (onLogoLoaded) {
            onLogoLoaded()
        }
    }, [onLogoLoaded])

    useEffect(() => {
        const src = ImageUtil.process(appContext.state.enterpriseInfo.logo_pc, {})
        setSrc(src);
    }, []);

    const click = useCallback(() => {
        if (entry) {
            entry();
        } else {
            toHome(true);
        }
    }, [entry]);

    return (
        <div className="logo">
            <a
                className={`page-header-logo ${trackEvent ? 'trackEvent' : ''}`}
                data-track-cat="{{::trackEvent.cat}}"
                data-track-label="{{::trackEvent.label}}"
                href="javascript:;"
                onClick={click}
            >
                <If condition={!!src}>
                    <img src={src} alt="" className="custom-logo" onLoad={handleLogoLoaded} />
                </If>
                <If condition={!src && !hideDefaultLogo}>
                    <div className="img"></div>
                </If>
            </a>
        </div>
    );
}
